import { Button, Col, Form, Upload } from 'antd'

import './styles.scss'
import { LuFileStack } from 'react-icons/lu'
import { TFieldProps } from '..'

export default function UploadMultipleFormField({
  fieldInfo,
  subsectionForm = false,
}: TFieldProps) {
  return (
    <Col xl={subsectionForm ? 24 : 8} md={subsectionForm ? 24 : 12} xs={24}>
      <Form.Item
        className={`upload-multiple-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
      >
        <Upload multiple>
          <Button className='upload-multiple-btn' icon={<LuFileStack />}>
            Adjuntar archivos
          </Button>
        </Upload>
      </Form.Item>
    </Col>
  )
}
